import {
  Component,
  ElementRef,
  ViewChild,
  inject,
} from '@angular/core';
import { LayoutService } from '../../services/layout/layout.service';
@Component({
    selector: 'kanzi-ui-top-bar-wms-admin',
    templateUrl: './kanzi-ui-top-bar-wms-admin.component.html',
    styleUrls: ['./kanzi-ui-top-bar-wms-admin.component.scss'],
    standalone: false
})
export class KanziUiTopBarWmsAdminComponent {
  @ViewChild('menuButton') menuButton!: ElementRef;
  @ViewChild('mobileMenuButton') mobileMenuButton!: ElementRef;

  layoutService: LayoutService = inject(LayoutService);
  activeItem!: number;
  languajes = [
    { value: 'en', label: 'Inglés', code: 'us' },
    { value: 'es', label: 'Español', code: 'es' },
  ];

  /**
   * Constructor
   * @param el {ElementRef} - ElementRef
   */
  constructor(public el: ElementRef) {}

  /**
   * Get mobile topbar active
   * return {boolean}
   */
  get mobileTopbarActive(): boolean {
    return this.layoutService.state.topbarMenuActive;
  }

  /**
   * Get menu toggle action
   */
  onMenuButtonClick() {
    this.layoutService.onMenuToggle();
  }

  /**
   * Get mobile topbar menu button click
   */
  onMobileTopbarMenuButtonClick() {
    this.layoutService.onTopbarMenuToggle();
  }



  get logo() {
    const logo =
      this.layoutService._config.menuTheme === 'light' ||
      this.layoutService._config.menuTheme === 'dark'
        ? 'dark'
        : 'white';
    return logo;
  }
}
